import { Helmet } from "react-helmet";

import EPImage from "../assets/images/EP.svg";

const ExercisePhysiology = () => {
  return (
    <main>
      <Helmet>
        <title>Exercise Physiology | Provido</title>
        <meta property="og:title" content="Exercise Physiology | Provido" />
        <meta
          name="description"
          content="Our exercise physiologists help you get back into the best shape possible."
        ></meta>
        <meta
          property="og:url"
          content="https://provido.com.au/services/exercise-physiology"
        />
        <meta name="twitter:title" content="Exercise Physiology | Provido" />
      </Helmet>

      {/* Page Header */}
      <div className="flex w-dvw flex-col gap-12 bg-lightblue bg-[url(./assets/images/bubblebg.webp)] px-8 py-12 md:px-24 lg:flex-row lg:gap-24 xl:px-48">
        <div className="flex items-center justify-center pb-6 text-center font-display text-6xl leading-18 text-blue sm:pb-0">
          Exercise Physiology
        </div>
        <p>
          Our Exercise Physiology services are designed to support people living
          with disability, chronic conditions, injury, or reduced mobility to
          improve their physical health, confidence, and overall wellbeing.
          <br />
          <br />
          Our Accredited Exercise Physiologists provide personalised exercise
          programs tailored to each participant’s individual goals, abilities,
          and lifestyle. We take a person-centred approach to care, creating
          safe, supportive, and engaging programs that help participants achieve
          meaningful outcomes at their own pace.
        </p>
      </div>

      {/* How We Can Help You */}
      <div className="px-6 py-16">
        <div className="mx-auto grid w-fit grid-cols-1 gap-12 md:grid-cols-3">
          <div className="flex flex-col justify-center md:col-span-2">
            <h2 className="pb-12 text-center font-display text-4xl text-purple">
              How We Can Help You
            </h2>
            <h3 className="pb-1 font-display text-xl text-blue">
              Our Exercise Physiologists can assist with:
            </h3>
            <ul className="text-list">
              <li>Improving strength and fitness</li>
              <li>Increasing mobility and flexibility</li>
              <li>Building balance and coordination</li>
              <li>Supporting pain management</li>
              <li>Reducing fatigue and improving energy levels</li>
              <li>Increasing independence with daily activities</li>
              <li>Building confidence with movement and exercise</li>
              <li>Developing healthy routines and lifestyle habits</li>
              <li>Supporting community participation</li>
              <li>Improving overall health and wellbeing</li>
            </ul>
          </div>
          <img
            src={EPImage}
            className="mx-auto -mb-16.5 h-96 md:h-full"
            alt="Illustration: a man cheering with his fist in the air."
          />
        </div>
      </div>

      {/* Who We Support */}
      <div className="w-dvw bg-skyblue bg-[url(./assets/images/darkbubblebg.webp)] px-8 py-24">
        <div className="mx-auto max-w-3xl text-white">
          <h2 className="pb-8 text-center font-display text-3xl text-blue lg:text-4xl">
            Who We Support?
          </h2>
          <p>
            We support participants living with a wide range of disabilities,
            health conditions, and support needs, including:
          </p>
          <ul className="text-list">
            <li>Neurological conditions</li>
            <li>Intellectual disabilities</li>
            <li>Autism Spectrum Disorder (ASD)</li>
            <li>Physical disabilities</li>
            <li>Chronic pain and fatigue conditions</li>
            <li>Mental health conditions</li>
            <li>Injury recovery and mobility limitations</li>
          </ul>
          <p>
            We are passionate about creating an inclusive and supportive
            environment where participants feel encouraged to work towards their
            goals and enjoy the benefits of movement in a way that works for
            them.
          </p>
        </div>
      </div>
    </main>
  );
};

export default ExercisePhysiology;
